import { ReactNode } from 'react'

interface AlertProps {
  icon?: ReactNode
  children: ReactNode
  variant?: 'info' | 'success' | 'warning' | 'error'
  className?: string
}

const variantStyles = {
  info: 'alert-info text-white',
  success: 'alert-success text-white',
  warning: 'alert-warning text-white',
  error: 'alert-error text-white',
}

export function Alert({ 
  icon, 
  children, 
  variant = 'info',
  className = '' 
}: AlertProps) {
  return (
    <div className={`alert ${variantStyles[variant]} ${className}`}>
      {icon}
      <span>{children}</span>
    </div>
  )
}
